import Button from '@mui/material/Button'
import {
    Box,
    Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { SelectRowFromTable, GetDensityNetworkConfigFile } from '../universal/Axios';
import { DensityNetworkConfigTable } from './DensityNetworkConfigTable';
import { CopyToClipboard } from '../universal/JSONHelper';

const EditDensityNetworkConfig = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [densityNetworkConfigObject, setDensityNetworkConfigObject] = useState([])
    const [parentID, setParentID] = useState(null)
    const [densityNetworkConfigFile, setDensityNetworkConfigFile] = useState("")

    const [backURL, setBackURL] = useState("")

    useEffect(() => {
        SelectRowFromTable("select * from density_network_config where id = '" + id + "';", setDensityNetworkConfigObject)
    }, []);
    useEffect(() => {
        if (densityNetworkConfigObject !== undefined) {
            setParentID(densityNetworkConfigObject.parent_id)
        }
    }, [densityNetworkConfigObject]);
    useEffect(() => {
        if (parentID === null) {
            setBackURL("density-network-configs")
        }
        else {
            setBackURL('edit-density-network-config?id=' + parentID)
        }
    }, [parentID]);


    useEffect(() => {
        GetDensityNetworkConfigFile(id, setDensityNetworkConfigFile)
    }, []);


    const BackLink = () =>
        <Button
            sx={{ marginLeft: '20px', textTransform: 'none', width: "140px" }}
            variant="contained"
            href={backURL}
        >
            {parentID === null ? "BACK TO DNCs" : "BACK TO PARENT"}
        </Button>
    if (densityNetworkConfigFile === "") {
        return <div>Loading...</div>
    }
    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <Typography variant="h6">{id}</Typography>
                </Box>
                <Box>
                    <BackLink />
                </Box>
            </Box>
            <Box sx={{ float: "right", marginTop: "15px" }}>
                <Button
                    sx={{ marginLeft: '20px' }}
                    variant="contained"
                    href={"create-density-network-config?id=" + id}
                >
                    Create DNC From Params
                </Button>
                <Button
                    sx={{ marginLeft: '20px', width: "140px" }}
                    variant="contained"
                    href={"upload-density-network-config?parent-id=" + id}
                >
                    Upload DNC
                </Button>
            </Box>
            <Box sx={{ m: 2 }}>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", margin: '20px', fontSize: '20px' }}>
                <b>Adjustment Configs:</b>
            </Box>
            <div style={{ height: 400, width: '100%' }}>
                <DensityNetworkConfigTable parent_id={id} />
            </div>
            <Box sx={{ display: "flex", justifyContent: "space-around", marginTop: '20px', fontSize: '20px' }}>
                <Box sx={{width: '33%', float: "left"}}></Box>
                <Box sx={{ width: '33%', textAlign: "center", margin: "auto", display: "inline-block", fontSize: '20px' }}>
                    <span sx={{ float: "right" }}><b>File Content:</b></span>
                </Box>
                <Box sx={{ width: '33%' }}>
                    <Button
                        onClick={() => CopyToClipboard(densityNetworkConfigFile)}
                        variant="contained"
                        sx={{ float: "right" }}
                    >
                        Copy to Clipboard
                    </Button>
                </Box>
            </Box>
            {densityNetworkConfigFile === "" && <div>Loading...</div>}
            <Box sx={{ display: "flex", justifyContent: "center", marginTop: '20px' }}>
                <Box component="div" sx={{ border: 1, overflow: 'auto', width: '1000px', height: '500px' }}>
                    <pre>{densityNetworkConfigFile}</pre>
                </Box>
            </Box>
        </Box>
    )
}

export default EditDensityNetworkConfig